import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { AuthProvider } from '@/features/auth/AuthContext'
import { StoreProvider } from '@/features/stores/StoreContext'
import { ProtectedRoute } from '@/features/auth/ProtectedRoute'
import { LoginPage } from '@/features/auth/LoginPage'
import { SignupPage } from '@/features/auth/SignupPage'
import { ForgotPasswordPage } from '@/features/auth/ForgotPasswordPage'
import { DashboardPage } from '@/features/dashboard/DashboardPage'
import { HomepagePage } from '@/features/homepage/HomepagePage'
import { CategoriesPage } from '@/features/categories/CategoriesPage'
import { ProductsPage } from '@/features/products/ProductsPage'
import { OrdersPage } from '@/features/orders/OrdersPage'
import { CustomersPage } from '@/features/customers/CustomersPage'
import { DiscountsPage } from '@/features/discounts/DiscountsPage'
import { AnalyticsPage } from '@/features/analytics/AnalyticsPage'
import { CategoryPagesPage } from '@/features/category-pages/CategoryPagesPage'
import { WebhooksPage } from '@/features/webhooks/WebhooksPage'
import { SettingsPage } from '@/features/settings/SettingsPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <StoreProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              
              {/* Protected routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/homepage" element={<HomepagePage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/category-pages" element={<CategoryPagesPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/customers" element={<CustomersPage />} />
                <Route path="/discounts" element={<DiscountsPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/webhooks" element={<WebhooksPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
              
              {/* Redirect root to dashboard */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Toaster />
          </StoreProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
